/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { DialogDefaultV2, ArquivoContainerV2 } from '../../../components/v2';

const ArquivosDialog = ({ open, onClose, pedidoId, findPedidoVooArquivosById }) => {
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && pedidoId) {
      setLoading(true);
      findPedidoVooArquivosById(pedidoId, (files) => {
        setArquivos(files || []);
        setLoading(false);
      });
    } else {
      setArquivos([]);
    }
  }, [open, pedidoId]);

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      title="Arquivos do Pedido de Voo"
      cancelMessage="Fechar"
      maxWidth="md"
      fullWidth
      useFullScreen={false}
      readOnly
    >
      {loading && (
        <Typography color="text.secondary" variant="body2">Carregando arquivos...</Typography>
      )}
      {!loading && arquivos.length === 0 && (
        <Typography color="text.secondary" variant="body2">Nenhum arquivo anexado neste pedido.</Typography>
      )}
      {!loading && arquivos.length > 0 && (
        <ArquivoContainerV2
          arquivos={arquivos}
          disabled
          onSave={() => {}}
        />
      )}
    </DialogDefaultV2>
  );
};

ArquivosDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  pedidoId: PropTypes.string,
  findPedidoVooArquivosById: PropTypes.func.isRequired,
};

ArquivosDialog.defaultProps = {
  pedidoId: null,
};

export default ArquivosDialog;
